function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchTableau from '@/components/SearchTableau';
import FormMetaReportDatastudio from '@/modules/tasks/datastudio/components/FormMetaReportDatastudio';
import PaginationTableau from '@/components/PaginationTableau';
import PaginationVue from '@/components/PaginationVue.vue';
import DialogsComponent from '@/components/DialogsComponent.vue';
import tasks from '@/js/tasks';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import utils from '@/js/utils';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
var NOT_REPORTS = 'There are not report to assign';
export default {
  name: 'DSContReportAssignment',
  components: {
    SearchTableau: SearchTableau,
    FormMetaReportDatastudio: FormMetaReportDatastudio,
    PaginationTableau: PaginationTableau,
    PaginationVue: PaginationVue,
    DialogsComponent: DialogsComponent
  },
  data: function data() {
    return {
      items: [],
      // Representa la colección de objetos
      data_list: [],
      data_rp: {},
      // representa los datos generales
      isBusy: false,
      messageLoading: textsDefaul.LOADING,
      messageEmptyList: NOT_REPORTS,
      path_name: '',
      limit: envConfig.pagintaionSize,
      page: 1,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      isValidateLink: false,
      is_prod_called: false,
      is_dev_called: true,
      dialogFlag: false,
      collapse_filter: false,
      DIALOG_ASSIGN: "DIALOG_ASSIGN",
      key_assign: 1,
      filter_enabled: false //true,
    };
  },
  computed: {
    fields: function fields() {
      return [{
        key: 'object_name',
        label: this.traductor('tablas.report'),
        sortable: true
      }, {
        key: 'data_operator',
        label: this.traductor('tablas.data_operator')
      },
      // { key: 'columns.length', label: 'Columns', class: 'text-center' },
      {
        key: 'environment',
        label: this.traductor('filtros.environment'),
        class: 'text-center'
      }, {
        key: 'creation_date',
        label: this.traductor('tablas.creation_time'),
        class: 'text-center'
      }, {
        key: 'action',
        label: this.traductor('tablas.actions'),
        class: 'w-18 text-center'
      }];
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('my_tasks.subtitle_report_lds_assignment'),
        disabled: true
      }];
    },
    headers: function headers() {
      return [{
        value: 'object_name',
        text: this.traductor('tablas.report'),
        sortable: true
      }, {
        value: 'data_operator',
        text: this.traductor('tablas.data_operator'),
        align: 'center'
      },
      // { key: 'columns.length', label: 'Columns', class: 'text-center' },
      {
        value: 'environment',
        text: this.traductor('filtros.environment'),
        class: 'text-center',
        align: 'center'
      }, {
        value: 'creation_date',
        text: this.traductor('tablas.creation_time'),
        class: 'text-center',
        align: 'center'
      }, {
        value: 'action',
        text: this.traductor('tablas.actions'),
        class: 'w-18 text-center',
        align: 'center'
      }];
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    isEmptyTable: function isEmptyTable() {
      return !this.items.length;
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    }
  },
  created: function created() {
    this.reloadList();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    refreshItem: function refreshItem(item) {
      var index = this.items.findIndex(function (record) {
        return record.dataset_id === item.dataset_id;
      });
      this.$set(this.items, index, item);
    },
    logicDelete: function logicDelete(item) {
      var _this = this;
      console.log("test: ", item);
      DatastudioReportService.logicDelete(item).then(function (response) {
        if (!response.success) {
          tasks.toast.error("Ha ocurrido un error, inténtelo nuevamente.");
          //this.$toast.warning("Error")
        } else {
          tasks.toast.success("Eliminado correctamente");
          //this.$toast.success("Eliminado correctamente")
          _this.reloadList();
        }
      });
    },
    onClickAssign: function onClickAssign(item) {
      var dataRequest = {
        domain: window.userInfo.domain,
        clauses: {
          document_id: item.id
        }
      };
      this.data_rp = null;
      /* biDatasetService.tableauDataSourceQuery(dataRequest).then((res) => {
        if (res.code === 200 && res.success) {
          this.data_rp = res.data.result
          this.path_name = `${this.data_rp.path_name}`
          this.$refs['my-modal'].show()
        }
      })*/
      this.data_rp = item;
      this.path_name = "".concat(this.data_rp.path_name);
      this.isValidateLink = true;
      //this.dialogFlag=true
      this.key_assign += 1;
      this.$refs[this.DIALOG_ASSIGN].onOpen();
      //this.$refs['my-modal-meta'].show()
    },
    processParams: function processParams(params, isProd) {
      var filters = [{
        key: 'environment',
        operator: 'in',
        value: isProd ? [ENVIRONMENT_FLOW.PROD] : [ENVIRONMENT_FLOW.DEV, ENVIRONMENT_FLOW.TEST]
      }];
      if (params && params.clauses) {
        var clauses = params.clauses;
        if (clauses.query_type !== 'advanced') {
          for (var _i = 0, _Object$keys = Object.keys(clauses); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            if (clauses[key] && clauses[key].trim()) {
              filters.push({
                key: key,
                operator: '==',
                value: clauses[key].trim()
              });
            }
          }
        }
      }
      return _objectSpread({
        domain: window.userInfo.domain,
        pagination: {
          limit: this.limit,
          offset: this.page
        },
        filters: filters
      }, params);
    },
    reloadList: function reloadList(params, isProd) {
      var _this2 = this;
      this.items = [];
      var defaultParams = this.processParams(params, isProd);
      this.isBusy = true;
      this.messageEmptyList = textsDefaul.LOADING;
      console.log(defaultParams);
      DatastudioReportService.getReports(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this2.items = res.data;
          _this2.data_list = Object.assign([], res.data);
          _this2.pagination.total = res.data.length;
          _this2.currentPage = 1;
          _this2.messageEmptyList = res.data.length === 0 ? NOT_REPORTS : null;
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      }).finally(function () {
        _this2.isBusy = false;
      });
    },
    onCloseModal: function onCloseModal() {
      //this.dialogFlag=false
      this.$refs[this.DIALOG_ASSIGN].onClose();
      //this.$bvModal.hide('my-modal-meta')
      this.reloadList();
      this.data_rp = {};
    },
    onSearchQuery: function onSearchQuery(data) {
      console.log("data search", data);
      this.pagination.current = 1;
      if (data.clauses && data.clauses.environment == 'prod' && !this.is_prod_called) {
        this.is_dev_called = false;
        this.is_prod_called = true;
        this.reloadList({}, true);
      } else if (data.clauses && data.clauses.environment != 'prod' && !this.is_dev_called) {
        this.is_dev_called = true;
        this.is_prod_called = false;
        this.reloadList({}, false);
      } else {
        if (data.clauses) {
          console.log(data, this.data_list);
          if (data.clauses.query_type == 'advanced') {
            var search = data.clauses.query.toUpperCase();
            this.items = this.data_list.filter(function (x) {
              return x.data_operator.toUpperCase().indexOf(search) != -1 || x.environment.toUpperCase().indexOf(search) != -1 || x.object_name.toUpperCase().indexOf(search) != -1 || x.path_name.toUpperCase().indexOf(search) != -1;
            });
          } else {
            this.items = Object.assign([], this.data_list);
            if (data.clauses.object_name) {
              this.items = this.items.filter(function (x) {
                return x.object_name.toUpperCase().indexOf(data.clauses.object_name.toUpperCase()) != -1;
              });
            }
            if (data.clauses.path_name) {
              this.items = this.items.filter(function (x) {
                return x.path_name.toUpperCase().indexOf(data.clauses.path_name.toUpperCase()) != -1;
              });
            }
            if (data.clauses.data_operator) {
              this.items = this.items.filter(function (x) {
                return x.data_operator.toUpperCase().indexOf(data.clauses.data_operator.toUpperCase()) != -1;
              });
            }
            // if (data.clauses.environment)
            //    this.items = this.items.filter(x => x.environment.toUpperCase().indexOf(data.clauses.environment.toUpperCase()) != -1)
          }
        } else {
          this.items = Object.assign([], this.data_list);
        }
        this.pagination.total = this.items.length;
      }
    },
    onPage: function onPage(page) {
      this.page = page;
      this.reloadList({
        page: page
      });
    },
    changePagina: function changePagina(pagina) {},
    openModalMeta: function openModalMeta() {
      this.data_rp = {};
      this.isValidateLink = true;
      this.key_assign += 1;
      //this.dialogFlag=true
      this.$refs[this.DIALOG_ASSIGN].onOpen();
      //this.$refs['my-modal-meta'].show()
    }
  }
};